import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import { updateSegments, loadById, loadByCarrierFlightNumberAndDate, setSingleFlightSecondarySearchAction } from './redux/actions';
import FlightTrackerComponent from './children/FlightTracker/FlightTracker';
import componentBase from '../../src/lib/component-base';
import { addMetaCanonical } from '../../shared/lib/meta-tags';
import { flightURL } from '../../src/lib/single-flight-util';
import { isNilOrEmpty } from '../../src/lib/ramda-extension';

@connect(state => ({
  segments: state.SingleFlightTracker.segments,
  flight: state.SingleFlightTracker.flight,
  error: state.SingleFlightTracker.error,
  loading: state.SingleFlightTracker.loading,
  loaded: state.SingleFlightTracker.loaded,
  refreshCount: state.SingleFlightTracker.refreshCount,
  secondarySearchAction: state.SingleFlightTracker.secondarySearchAction,
}))
@componentBase('FlightTrackerContainer')
export default class FlightTrackerContainer extends React.Component {
  static propTypes = {
    segments: PropTypes.array,
    flight: PropTypes.object,
    error: PropTypes.object,
    location: PropTypes.object,
    dispatch: PropTypes.func,
    match: PropTypes.object,
    secondarySearchAction: PropTypes.bool,
  };

  componentDidMount() {
    this.loadFlight(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch, secondarySearchAction, location: prevLocation } = this.props;
    const { pathname: prevPathname } = prevLocation;
    const {
      error, flight, segments, location: nextLocation,
    } = nextProps;
    const { pathname: nextPathname } = nextLocation;

    if (error && error.code) {
      dispatch(push(`/flight-tracker/search/advanced?error=${error.code}`));
      return;
    }

    if (prevPathname !== nextPathname) {
      this.loadFlight(nextProps);
    } else if (secondarySearchAction) {
      dispatch(setSingleFlightSecondarySearchAction(false));
    } else if (!isNilOrEmpty(flight) && isNilOrEmpty(segments)) {
      const redirPathname = `/flight-tracker/${flightURL(flight)}`;
      (nextPathname !== redirPathname) && dispatch(replace(redirPathname));
    }
  }

  loadFlight = (props) => {
    const { dispatch, match } = props;
    const { params } = match;
    const {
      flightId, year, month, day,
    } = params;

    if (year && month && day) {
      dispatch(loadByCarrierFlightNumberAndDate(params));
    } else {
      dispatch(updateSegments([]));
      dispatch(loadById(flightId));
    }
  };

  meta = () => (addMetaCanonical({ title: 'Flight Tracker' }, this.props.location.pathname));

  render() {
    const { match } = this.props;
    const { params } = match;

    return (
      <div className='container'>
        <Helmet {...this.meta()} />
        <FlightTrackerComponent {...this.props} params={params} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/SingleFlight/container.js